import React, { useState, useEffect, useContext } from "react";
import NormalLayout from "../../components/layout/NormalLayout";
import axios from "axios";
import {
  Table,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { orderStatus } from "../../utils/ConvertWord";
import Moment from "react-moment";
import ReactPaginate from "react-paginate";
import { AuthContext } from "../../context/AuthContext";
import { Cookies } from "react-cookie";
const cookies = new Cookies();

function Registered() {
  const [data, setData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0); // 전체 페이지 수
  const [count, setCount] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false); // 드롭다운의 열림/닫힘 상태
  const [pageSize, setPageSize] = useState(10); // 페이지당 노출수 설정

  const toggle = () => setDropdownOpen((prevState) => !prevState); // 드롭다운 상태 토글

  // 드롭다운에서 항목 선택 시, 페이지당 노출수 업데이트
  const selectPageSize = (size) => {
    setCurrentPage(0);
    setPageSize(size);
  };

  useEffect(() => {
    excelListData();
  }, [currentPage, pageSize]);

  const excelListData = async () => {
    try {
      const encodedWholesaler = encodeURIComponent(cookies.get("info").profile);
      const resList = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/manage/order?status=REGISTERED&page=${currentPage}&limit=${pageSize}&wholesaler=${encodedWholesaler}`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        }
      );

      // 데이터가 있을 경우
      if (resList.data.result === "success") {
        setData(resList.data.data.list);
        setCount(resList.data.data.count.count);
        setPageCount(Math.ceil(resList.data.data.count.count / pageSize));
      } else {
        // 데이터가 없는 경우 (삭제 후 페이지가 비어있는 경우 등)
        // 빈 배열로 설정하여 삭제된 항목이 화면에 남지 않도록 함
        setData([]);
        // count는 0으로 설정하거나, 이전 count에서 1을 빼는 방식도 가능
        // 하지만 서버에서 정확한 count를 가져오는 것이 더 안전
        setCount(0);
        setPageCount(0);
      }
    } catch (error) {
      console.error("데이터를 불러오는데 실패했습니다", error);
    }
  };

  // 페이지가 변경될 때마다 실행될 함수
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  // 주문건별 총 상품금액 계산함수
  const genAmount = (items) => {
    let amount = 0.0;

    items.map((item) => {
      let price = convertPriceFormat(
        item.productCode,
        item.unitPrice,
        item.qauntity
      ).replace("$", "");
      if (!isNaN(price)) {
        amount += parseFloat(price);
      }
    });

    return amount.toFixed(2);
  };

  const convertPriceFormat = (productCode, unitPrice, qauntity) => {
    let resValue = null;
    if (!productCode) {
      return "미정";
    }
    let pcode = productCode.toUpperCase();

    // 예외처리 코드 : BRING, CHEMIST, MART, PROMO, SPECIAL, 공백
    if (pcode === "BRING" || pcode === "PROMO") {
      resValue = "$0";
    } else if (
      pcode === "CHEMIST" ||
      pcode === "MART" ||
      pcode === "SPECIAL" ||
      pcode === ""
    ) {
      resValue = "미정";
    } else {
      resValue =
        "$" +
        parseFloat(unitPrice * qauntity)
          .toFixed(2)
          .toString();
    }

    return resValue;
  };

  const deleteOrder = async (orderIndex, wholesaler) => {
    try {
      const encodedWholesaler = encodeURIComponent(cookies.get("info").profile);
      const resList = await axios.delete(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/manage/order?orderindex=${orderIndex}&wholesaler=${encodedWholesaler}`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        }
      );
      if (resList.data.result === "success") {
        return true;
      } else {
        console.error("주문건을 삭제하는데 실패했습니다");
        return false;
      }
    } catch (error) {
      console.error("주문건을 삭제하는데 실패했습니다", error);
      return false;
    }
  };

  const handleDelete = async (orderIndex, wholesaler, name) => {
    // 사용자에게 확인을 요청하는 알림 표시
    const isConfirmed = window.confirm(`${name}님 주문을 삭제하시겠습니까?`);

    if (isConfirmed) {
      const deleteSuccess = await deleteOrder(orderIndex, wholesaler);
      if (deleteSuccess) {
        // 삭제 성공 후 목록 새로고침
        // 현재 페이지의 마지막 항목을 삭제한 경우를 대비해
        // 먼저 현재 페이지 데이터를 새로고침
        await excelListData();
        
        // 새로고침 후에도 데이터가 비어있고 현재 페이지가 0보다 크면 이전 페이지로 이동
        // excelListData가 완료된 후 상태가 업데이트되므로, 
        // useEffect를 통해 자동으로 처리되도록 currentPage를 변경
        const newCount = count - 1;
        const newPageCount = Math.ceil(newCount / pageSize);
        
        if (currentPage >= newPageCount && newPageCount > 0) {
          // 현재 페이지가 삭제 후 마지막 페이지보다 크거나 같으면 이전 페이지로 이동
          setCurrentPage(newPageCount - 1);
        }
        // 그 외의 경우는 excelListData()에서 이미 상태가 업데이트됨
      }
    } else {
      // 사용자가 '취소'를 클릭했을 때 수행할 작업
      console.log("사용자가 삭제를 취소했습니다.");
    }
  };

  return (
    <NormalLayout>
      <div>
        <h3>주문등록 완료 {count && count !== 0 ? <>({count}건)</> : <></>}</h3>
      </div>
      <div className="p-3"></div>
      {data ? (
        <>
          <div className="border p-3">
            <div className="mb-3">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret color="dark">
                  페이지당 노출 수: {pageSize}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => selectPageSize(10)}>
                    10개
                  </DropdownItem>
                  <DropdownItem onClick={() => selectPageSize(30)}>
                    30개
                  </DropdownItem>
                  <DropdownItem onClick={() => selectPageSize(50)}>
                    50개
                  </DropdownItem>
                  <DropdownItem onClick={() => selectPageSize(100)}>
                    100개
                  </DropdownItem>
                  <DropdownItem onClick={() => selectPageSize(300)}>
                    300개
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>{" "}
            </div>
            <Table hover bordered>
              <thead>
                <tr className="table-primary">
                  <th className="text-center">No</th>
                  <th className="text-center p-2 border">이름</th>

                  <th className="text-center p-2 border">전화번호</th>
                  <th className="text-center p-2 border">모바일번호</th>
                  <th className="text-center p-2 border">통관부호</th>
                  <th className="text-center p-2 border">우편번호</th>
                  <th className="text-center p-2 border">주소</th>
                  <th className="text-center p-2 border">요청메모</th>
                  <th className="text-center p-2 border">배송메모</th>
                  <th className="text-center p-2 border">주문상품</th>
                  <th className="text-center p-2 border">
                    예상금액
                    <br />
                    (배송비 제외)
                  </th>
                  <th className="text-center p-2 border">기능</th>
                </tr>
              </thead>
              <tbody>
                {data.map((o, idx) => {
                  return (
                    <tr key={idx}>
                      <td className="text-center">
                        {idx + 1 + currentPage * pageSize}
                      </td>
                      <td className="text-center">{o.customer_name}</td>
                      <td className="text-center">{o.customer_tel}</td>
                      <td className="text-center">{o.customer_mobile}</td>
                      <td className="text-center">{o.pcc}</td>

                      <td className="text-center">{o.zip}</td>
                      <td>{o.address}</td>
                      <td className="text-center">{o.shipper_memo}</td>
                      <td>{o.delivery_memo}</td>
                      <td style={{ padding: "0px" }}>
                        <Table
                          bordered
                          style={{ margin: "0px", width: "100%" }}
                        >
                          <tbody>
                            {o.order_product.map((i, index) => {
                              return (
                                <tr key={index}>
                                  <td
                                    className="text-center"
                                    style={{ width: "70px" }}
                                  >
                                    {i.productCode}
                                  </td>

                                  <td className="cell">{i.productName}</td>
                                  <td
                                    style={{ width: "60px" }}
                                    className="text-center"
                                  >
                                    {i.qauntity}개
                                  </td>
                                  <td
                                    style={{ width: "70px" }}
                                    className="text-center"
                                  >
                                    {convertPriceFormat(
                                      i.productCode,
                                      i.unitPrice,
                                      i.qauntity
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </td>
                      <td className="text-center">
                        ${genAmount(o.order_product)}
                      </td>
                      <td className="text-center" style={{ width: "80px" }}>
                        <Button
                          color="danger"
                          style={{ fontSize: "12px" }}
                          onClick={() =>
                            handleDelete(
                              o.order_index,
                              o.wholesaler,
                              o.customer_name
                            )
                          }
                        >
                          삭제
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <ReactPaginate
                previousLabel={"이전"}
                nextLabel={"다음"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"item active "}
                breakClassName={"item break-me "}
                pageClassName={"item pagination-page "}
                disabledClassName={"disabled-page"}
              />
            </div>
          </div>
        </>
      ) : (
        <>주문 데이터 없음</>
      )}
    </NormalLayout>
  );
}

export default Registered;
